module.exports = __webpack_public_path__ + "img/ic_order_canceled_customer_circle_filled.a4a2f759.png";